import { MAX_DISPLAYED_DMS_ON_LB_CARD } from '../../shared/types';

import type { DmsWithLegislativeBodies, NormalizedDMsAndLBs } from './types';

export const normalizeDmsAndLBs = (dmsAndLBs: DmsWithLegislativeBodies | undefined): NormalizedDMsAndLBs => {
	if (!dmsAndLBs) return [];

	return dmsAndLBs.map((item) => {
		const normalizeDMs = item.decisionMakers.map((dm) => normalizeDM(dm, item.location));
		const viewMoreCount = Math.max(0, item.decisionMakers.length - MAX_DISPLAYED_DMS_ON_LB_CARD);
		const responseCount = item.decisionMakers.filter((dm) => dm.recentResponse).length;

		const location = item.location && item.bodyTitle?.includes(item.location) ? null : item.location;

		if (item.decisionMakers.length === 1) {
			return {
				type: 'single',
				displayedDMs: normalizeDMs,
			};
		}
		return {
			type: 'legislative_body',
			title: item.bodyTitle || '',
			location,
			displayedDMs: normalizeDMs.slice(0, MAX_DISPLAYED_DMS_ON_LB_CARD),
			allDMs: normalizeDMs,
			responseCount,
			viewMoreCount,
		};
	});
};

const getConstituentsCount = (constituentCountAmongSignersLocalized: string | null) => {
	const constituentCountLocalized = constituentCountAmongSignersLocalized ?? '0';
	return {
		constituentCount: parseInt(constituentCountLocalized.replace(/,/g, ''), 10) || 0,
		constituentCountLocalized,
	};
};

const normalizeDM = (dm: DmsWithLegislativeBodies[number]['decisionMakers'][number], location: string | null) => {
	const { constituentCount, constituentCountLocalized } = getConstituentsCount(
		dm.constituentCountAmongSignersLocalized,
	);

	return {
		id: dm.id,
		displayName: dm.displayName,
		slug: dm.slug,
		title: dm.title,
		publiclyVisible: dm.publiclyVisible,
		type: dm.type,
		location: location && dm.title?.includes(location) ? null : location,
		photoUrl: dm.photo?.userMedium.processing ? null : (dm.photo?.userMedium.url ?? null),
		response: dm.recentResponse,
		constituentCountLocalized,
		constituentCount,
		isFormer: dm.title?.startsWith('Former') || false,
		titleStrippedDown: null,
		isAutoAdded: false,
	};
};
